import { Capacitor, registerPlugin } from '@capacitor/core'

// iOS-only local plugin (registered in BeaconViewController.swift). Recreates
// the WKWebView so the bundle boots in a fresh content process with no stale
// IndexedDB locks. Absent on Android and on older iOS shells.
export const WebViewRestart = registerPlugin<{ restart(): Promise<void> }>('WebViewRestart')

export const canRestartWebView = () => Capacitor.isPluginAvailable('WebViewRestart')

// Read back by useOTACheck on the next boot so the user lands on the same page.
export const RESTORE_PATH_KEY = 'ota_restore_path'

// The outgoing WebView keeps running for a moment after a restart is requested,
// and its Firestore often breaks in that window (#406). Recovery must not
// restart again on top of a restart already in flight.
let restartInFlight = false
export const isRestartInFlight = () => restartInFlight

export type RestartKind = 'ota_restart' | 'recovery_restart' | 'chunk_reload'
const BOOT_KIND_KEY = 'next_boot_kind'

export function markRestartInFlight(kind: RestartKind) {
  restartInFlight = true
  localStorage.setItem(BOOT_KIND_KEY, kind)
}

// What started this session — read once at boot; a session not preceded by one
// of our own restarts is a cold start.
export function consumeBootKind(): RestartKind | 'cold' {
  const kind = localStorage.getItem(BOOT_KIND_KEY)
  localStorage.removeItem(BOOT_KIND_KEY)
  return kind === 'ota_restart' || kind === 'recovery_restart' || kind === 'chunk_reload' ? kind : 'cold'
}

export function saveRestorePath() {
  const currentPath = window.location.pathname + window.location.search + window.location.hash
  if (currentPath && currentPath !== '/') localStorage.setItem(RESTORE_PATH_KEY, currentPath)
  return currentPath
}
